export const gitHash = () => (document.getElementsByName("x-version")[0] as HTMLMetaElement).content
